import { render } from "./ShareRecording.vue?vue&type=template&id=3d6b2295&scoped=true&ts=true"
import script from "./ShareRecording.vue?vue&type=script&lang=ts"
export * from "./ShareRecording.vue?vue&type=script&lang=ts"

import "./ShareRecording.vue?vue&type=style&index=0&id=3d6b2295&scoped=true&lang=css"

import exportComponent from "/Users/pkraeutli/development/reca/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6b2295"]])

export default __exports__